/* eslint react/no-string-refs: 0 */
import React from 'react'
import cx from 'classnames'
import { includes } from 'libraries/lodash'
import { Subject } from 'rxjs'
import { debounceTime, switchMap, map } from 'rxjs/operators'
import { toast } from 'react-toastify'
import ClockIcon from '@material-ui/icons/AccessTime'
import ErrorIcon from '@material-ui/icons/Error'
import CheckIcon from '@material-ui/icons/CheckCircle'
import { EncryptionKeys, loadKey, pushEncryptionKeyUrl } from 'front-end-core/services/EncryptionService'
import Component from 'components/base/Component'
import connect from 'components/shared/connect'
import Icon from 'components/shared/Icon'
import notificationToast from 'helpers/notificationToast'

@connect(
  EncryptionKeys.pipe(map(keys => ({ existingUrls: keys.map(k => k.uri) })))
)
class EncryptionKeyOverlay extends Component {
  constructor (props) {
    const Input = new Subject()

    super(
      props,
      Input.pipe(debounceTime(1000), switchMap(loadKey), map(validated => ({ validated, errorMessage: validated ? null : 'Unable to load key' }))),
      {
        url: '',
        errorMessage: null,
        submitting: false,
        validated: false
      }
    )

    this.handleInputChange = ({ target: { value } }) => {
      if (includes(this.props.existingUrls, value)) {
        this.setState({ url: value, validated: false, errorMessage: 'Key already exists' })
      } else {
        Input.next(value)
        this.setState({ url: value, validated: false, errorMessage: null })
      }
    }
  }

  handleFormSubmit = (e) => {
    const { pageToggleOverlay } = this.props
    const { validated, submitting, url } = this.state

    e.preventDefault()
    if (validated && !submitting) {
      const notificationId = notificationToast(<ClockIcon />, toast.TYPE.INFO, 'Saving', '', false)
      this.setState({ submitting: true })

      pushEncryptionKeyUrl(url)
        .subscribe(({ success }) => {
          toast.dismiss(notificationId)
          if (!success) {
            this.setState({ submitting: false })
            notificationToast(<ErrorIcon />, toast.TYPE.ERROR, 'Unable to save, please try again', 'bg-indian-red white')
            this.refs.url.focus()
          } else {
            notificationToast(<CheckIcon />, toast.TYPE.SUCCESS, 'Encryption key added successfully', 'bg-dark-sea-green white')
            pageToggleOverlay(null)
          }
        })
    }
  }

  handleSetDefault = (e) => {
    e.preventDefault()
    this.handleInputChange({ target: { value: 'default.fckey' } })
  }

  componentDidMount () {
    super.componentDidMount()
    this.refs.url.focus()
  }

  render () {
    const { errorMessage, submitting, url, validated } = this.state
    const { pageToggleOverlay } = this.props

    const handleOnCancelClick = () => pageToggleOverlay(null)

    return (
      <div className='account-overlay'>
        <h2 className='pb4 f3 bb b--phantom-grey'>Add new encryption key</h2>
        <form onSubmit={this.handleFormSubmit} className=' flex flex-column justify-around'>
          <div className='flex flex-column-m flex-wrap justify-between items-baseline'>
            Enter Url
            <div className='flex flex-column w-65 w-100-m mb6'>
              <input ref='url' className='w-100 h3 ma0 f5' disabled={submitting} value={url} onChange={this.handleInputChange} />
              <span className='f6 i mt4'>External urls need to be https and have CORS enabled.</span>
            </div>
          </div>
          <div>
            {errorMessage && (
              <div className='tc crimson mt6 mb8'>
                <Icon name='icon-alert-circle' /> {errorMessage}
              </div>
            )}
            {!submitting && (
              <div className='buttons tr tc-m'>
                <button
                  type='submit'
                  onClick={this.handleSetDefault}
                  className='bg-void-grey black pv3 ph5 ba b--transparent br2 normal f6 lh-copy-variant hover-o-90'
                >
                  Set default key url
                </button>
                <button
                  type='submit'
                  className={cx('bg-teal white hover-white pv3 ph5 ba b--transparent br2 normal f6 lh-copy-variant mh4', {
                    'not-allowed o-10': !validated
                  })}
                  disabled={!validated}
                >
                  Submit
                </button>
                <button
                  type='reset'
                  onClick={handleOnCancelClick}
                  className='bg-void-grey black pv3 ph5 ba b--transparent br2 normal f6 lh-copy-variant hover-o-90'
                >
                  Cancel
                </button>
              </div>
            )}
          </div>
        </form>
      </div>
    )
  }
}

EncryptionKeyOverlay.disableOutsideToggle = true

export default EncryptionKeyOverlay
